import { Cancel, CheckCircle, Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import clsx from 'clsx';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AssignersDrawer = ({ assigners, setAssigners, name }) => {
  const { t } = useTranslation('translations');

  const renderAsigners = () => {
    if (Boolean(assigners) && !assigners?.length)
      return <p className="flex justify-center align-center">{t('NoAssigners')}</p>;

    return (
      <div className="max-w-[300px] w-full m-20 md:max-w-[360px]">
        {assigners?.map((assigner, index) => {
          const isAssigned = assigner.approverStatus === 0;
          const isRejected = assigner.approverStatus === 1;

          const icon = isAssigned ? (
            <CheckCircle className="text-green-700 w-16" />
          ) : isRejected ? (
            <Cancel className="text-red-700 w-16" />
          ) : null;

          return (
            <div
              key={index}
              className="rounded-lg mb-3 p-5 bg-white dark:bg-[#1a1a1a] border-2 border-solid"
            >
              <div className="flex justify-between items-center mb-3">
                <p className="font-bold">{assigner.name}</p>
              </div>

              <div className="flex items-center gap-5 justify-between">
                <span
                  className={clsx(
                    'text-xs font-medium px-2 py-1 rounded',
                    isAssigned
                      ? 'bg-green-100 text-green-700 dark:bg-green-700 dark:text-white'
                      : isRejected
                      ? 'bg-red-100 text-red-700 dark:bg-red-700 dark:text-white'
                      : 'bg-blue-100 text-blue-700 dark:bg-blue-700 dark:text-white'
                  )}
                >
                  {assigner.statusName}
                </span>
                {(isAssigned || isRejected) && assigner.updateDate ? (
                  <p className="text-sm">
                    {moment(assigner.updateDate).format('DD.MM.YYYY HH:mm')}
                  </p>
                ) : null}
                {icon}
              </div>
              {assigner?.comment && (
                <div className="text-12">
                  <p>
                    {t('Comment')}: {assigner.comment}
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <Drawer anchor="right" open={Boolean(assigners)} onClose={() => setAssigners(null)}>
      <Box sx={{ width: { md: 400, xs: 343 } }} role="presentation">
        <div className="flex gap-10 items-center pt-16 pl-3">
          <IconButton onClick={() => setAssigners(null)}>
            <Close />
          </IconButton>
          <h4 className="font-inter font-700 text-xl text-[#16151c] dark:text-white">{name}</h4>
        </div>
        {renderAsigners()}
      </Box>
    </Drawer>
  );
};

export default AssignersDrawer;
